import React, { useEffect, useMemo, useState } from "react";
import { usePackageInstance } from "../../../../Providers/PackageInstanceProvider";
import makeStyles from "@mui/styles/makeStyles";
import Box from "@mui/material/Box";
import TemplateProductPreview from "./TemplateProductPreview";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import { Container, Dialog } from "@mui/material";
import TemplateInstanceProvider, {
  ACTIONS,
  createInstance,
  getFirstRenderPartByResource,
  getImageResourceSize,
  getTemplateImageRotation,
  getTemplateTranslation,
  getUserImageResources,
} from "../../../../Providers/TemplateInstanceProvider";
import useTemplate from "../../../../hooks/useTemplate";
import { usePriceList } from "../../../providers/PriceListProvider";
import EditTemplateProduct from "./EditTemplateProduct";
import useTemplateInstance from "../../hooks/useTemplateInstance";
import { Trans, useTranslation } from "react-i18next";
import LoadingButton from "../../../../components/LoadingButton";
import GreenScreenBackgroundsProvider from "../../Providers/GreenScreenBackgroundsProvider";
import { usePictureSet } from "../../hooks/usePictureSet";
import EpmsImage from "../../../../components/Common/EpmsImage";
import i18next from "i18next";
import DigitalFileIcon from "../../../../components/Icons/DigitalFileIcon";
import CatalogueIcon from "../../../../components/Icons/CatalogueIcon";
import { callAPI } from "../../../../lib/common";
import { usePortal } from "../../../../Providers/PortalProvider";
import { calculateCropRect, getBoxSize } from "../../../../utils";
import { Prompt } from "react-router";
import { usePictureSets } from "../../../hooks/usePictureSets";
import ImageAllowedValidator from "../../../../components/Template/ImageAllowedValidator";
import * as PropTypes from "prop-types";
import { getCropRectForImageWithRotation } from "@/react/components/Template/common";
import { useAddToCartUseBuyNow } from "@/react/Webshop/hooks/useAddToCartUseBuyNow";

const useStyles = makeStyles((theme) => ({
  containerBox: {
    backgroundColor: theme.palette.secondary.light,
    paddingBottom: theme.spacing(4),
  },
  productList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  productTemplateList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "grid",
    [theme.breakpoints.up("xs")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
    [theme.breakpoints.up("lg")]: {
      gridTemplateColumns: "repeat(4, 1fr)",
    },
    gridGap: theme.spacing(1),
    "& > li": {
      position: "relative",
    },
  },
  packageHeaderContainer: {
    textAlign: "center",
    marginBottom: theme.spacing(2),
  },
  packageHeaderSmallText: {
    fontSize: "15px",
    color: "#232323",
  },
  packageHeaderPackageName: {
    color: theme.palette.primary.dark,
    fontSize: "20px",
    fontWeight: 500,
  },
  packageItemContainer: {},
  templatePreviewContainer: {
    position: "relative",
    marginBottom: theme.spacing(2),
    "& .template-inner-container": {
      boxShadow: "0px 3px 6px #00000029",
    },
  },
  templateName: {
    textAlign: "center",
    fontSize: "12px",
  },
  productName: {
    margin: 0,
    fontSize: "12px",
    fontWeight: 500,
    fontStyle: "italic",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    position: "relative",
    overflow: "hidden",
    textAlign: "center",
    color: "#232323",
    "& > span": {
      display: "inline-block",
      color: "inherit",
      position: "relative",
    },
    "& > span::after": {
      //left: '100%'
    },
    "& > span::before": {
      right: "100%",
    },
    "& > span::after, & > span::before": {
      content: "''",
      position: "absolute",
      top: "50%",
      borderBottom: "1px solid",
      width: "300px",
      margin: "0 10px",
      color: "#232323",
    },
  },
  pictureSetContainer: {
    position: "relative",
    height: "100px",
    "& img": {
      height: "100px",
    },
  },
  catalogueContainer: {
    display: "flex",
    height: "100px",
    flexDirection: "column",
    textAlign: "center",
    alignItems: "center",
  },
  pictureSetImageContainer: {
    position: "absolute",
    top: 0,
    left: 0,
  },
  digitalFileIconContainer: {
    width: "32px",
    height: "40px",
    position: "absolute",
    right: "0px",
    top: "-10px",
  },
}));

function PackageProductName({ packageProduct }) {
  const classes = useStyles();
  const getProductByUuid = usePriceList().getProductByUuid;

  const productName = useMemo(() => {
    return getProductByUuid(packageProduct.uuid).name;
  }, [packageProduct, getProductByUuid]);

  return (
    <h4 className={classes.productName}>
      <span>{productName}</span>
    </h4>
  );
}

PackageProductName.propTypes = { packageProduct: PropTypes.func };

const EditPackage = ({ mode, handleUpdateCart }) => {
  const classes = useStyles();
  const { state, updatePackageItem } = usePackageInstance();
  const { currentPictureSet } = usePictureSets();
  const [editPackageItemUuid, setEditPackageItemUuid] = useState("");
  const { t } = useTranslation();
  const useBuyNow = useAddToCartUseBuyNow();
  const portal = usePortal();
  const { getProductByUuid } = usePriceList();

  const packageProducts = useMemo(() => {
    const packageProducts = state.packageItems
      .filter((i) => i.type == "TEMPLATE_PRODUCT")
      .map((i) => i.product)
      .filter(
        (v, i, a) =>
          i ==
          a.findIndex((p) => {
            return p.uuid == v.uuid;
          }),
      );

    console.log("Package products", packageProducts);
    return packageProducts.map((product) => {
      return {
        ...product,
        packageItems: state.packageItems.filter(
          (item) => item.product.uuid == product.uuid,
        ),
      };
    });
  }, [state.packageItems]);

  const catalogue = useMemo(() => {
    return state.packageItems.find((item) => item.type == "CATALOGUE");
  }, [state.packageItems]);

  const digitalSet = useMemo(() => {
    return state.packageItems.find((item) => item.type == "DIGITAL_SET");
  }, [state.packageItems]);

  const handleChangeAllPictures = async (image) => {
    for (const packageItem of state.packageItems) {
      if (packageItem.type != "TEMPLATE_PRODUCT") {
        console.log("[Replace all] Skipping non template product");
        continue;
      }

      console.log("Package item__", packageItem);
      const template = await callAPI(
        "/api/webshop/templates/by-uuid/" + packageItem.template.uuid,
      );

      console.log("[Replace all] Template loaded");

      const product = getProductByUuid(packageItem.product.uuid);
      const { year, userResources, clientCompatibilityDate } =
        packageItem.templateData;

      const inst = createInstance(template, userResources, year, product);
      inst.clientCompatibilityDate = clientCompatibilityDate;

      const _userResources = { ...packageItem.templateData.userResources };

      const imageAllowedValidator = new ImageAllowedValidator(
        template,
        portal.webshop.template,
      );

      for (const userResource of getUserImageResources(inst)) {
        try {
          imageAllowedValidator.imageAllowedInResource(image, userResource);
        } catch (err) {
          console.log(
            "[Replace all] Image not allowed",
            image,
            userResource,
            err,
          );
          continue;
        }

        const renderPart = getFirstRenderPartByResource(
          userResource,
          inst.template,
        );
        if (!renderPart) {
          console.log(
            "[Replace all] Unable to find render part for",
            userResource,
          );
          continue;
        }

        const rotation = getTemplateImageRotation(
          inst.template,
          userResource,
          image,
        );

        const cropRect = getCropRectForImageWithRotation(
          { width: image.width, height: image.height },
          renderPart,
          rotation,
          portal.webshop.template.portraitOrientationGravity,
        );

        console.log(
          "Adding new resource based on renderpart, rotation, gravity",
          renderPart,
          rotation,
          portal.webshop.template.portraitOrientationGravity,
          cropRect,
        );
        const newResource = {
          ...userResource,
          image: {
            ...image,
            cropRect,
            rotation,
          },
        };

        console.log("Saving new resource", newResource);

        _userResources[userResource.fullId] = newResource;
      }
      const newData = {
        ...packageItem,
        version: packageItem.version ? packageItem.version + 1 : 1,
        template: {
          name: getTemplateTranslation(template.name, i18next.language),
          uuid: template.uuid,
        },
        templateData: {
          ...packageItem.templateData,
          year: year,
          userResources: _userResources,
          clientCompatibilityDate: clientCompatibilityDate,
        },
      };
      console.log("[Package item updated");
      updatePackageItem(newData);
    }
    setEditPackageItemUuid("");
  };

  console.log("[Package rerender]");

  const handleCartButtonClick = (data, year, template) => {
    const packageItem = state.packageItems.find(
      (pi) => pi.uuid == editPackageItemUuid,
    );
    console.log("Data is", data);
    const newData = {
      ...packageItem,
      template: {
        name: getTemplateTranslation(template.name, i18next.language),
        uuid: template.uuid,
      },
      templateData: {
        ...packageItem.templateData,
        year: year,
        userResources: data.reduce((object, userResource) => {
          object[userResource.fullId] = userResource;
          return object;
        }, {}),
      },
    };
    updatePackageItem(newData);
    setEditPackageItemUuid("");
  };

  console.log("Job", state.job, state.name);
  console.log("Edit package item", packageProducts, editPackageItemUuid);

  console.log("The prompt is dirty", state.dirty);
  return (
    <GreenScreenBackgroundsProvider jobUuid={currentPictureSet?.job.uuid}>
      <Prompt
        when={state.dirty && !state.isAddingToCart}
        message={t(
          "Are you sure you want to leave the page with unsaved changes?",
        )}
      />

      <Container className={classes.root}>
        <Box className={classes.containerBox} p={2}>
          <div className={classes.packageHeaderContainer}>
            <div className={classes.packageHeaderSmallText}>
              <Trans>
                <div>This is how</div>
                <div className={classes.packageHeaderPackageName}>
                  {{ packageName: state.name }}
                </div>
                <div className={classes.packageHeaderSmallText}>
                  with your photos will look
                </div>
              </Trans>
            </div>
          </div>
          <Box display="flex" justifyContent="center">
            <LoadingButton
              isLoading={state.isAddingToCart}
              variant="primary"
              color="primary"
              size="large"
              onClick={handleUpdateCart}
            >
              {mode == "update"
                ? t("Update package in cart")
                : useBuyNow
                  ? t("Buy now")
                  : t("Add package to cart")}
            </LoadingButton>
          </Box>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={2}
            mb={2}
            style={{ gap: "0.3em" }}
          >
            <Trans>
              Press <EditIcon /> to edit the content
            </Trans>
          </Box>
          <ul className={classes.productList}>
            {packageProducts.map((packageProduct) => {
              return (
                <li key={packageProduct.uuid}>
                  <PackageProductName packageProduct={packageProduct} />

                  <ul className={classes.productTemplateList}>
                    {packageProduct.packageItems.map((packageItem, idx) => {
                      return (
                        <li key={idx}>
                          <PackageItemContainer
                            packageItem={packageItem}
                            onEdit={() =>
                              setEditPackageItemUuid(packageItem.uuid)
                            }
                          />
                        </li>
                      );
                    })}
                  </ul>
                </li>
              );
            })}
            {catalogue && (
              <li>
                <h4 className={classes.productName}>
                  <span>
                    <Trans>Catalogue</Trans>
                  </span>
                </h4>
                <ul className={classes.productTemplateList}>
                  <li>
                    <CataloguePreview
                      packageItem={catalogue}
                      subject={state.subject}
                    />
                  </li>
                </ul>
              </li>
            )}
            {digitalSet && (
              <li>
                <h4 className={classes.productName}>
                  <span>
                    <Trans>Digital portrait set</Trans>
                  </span>
                </h4>
                <ul className={classes.productTemplateList}>
                  <li>
                    <DigitalSetPreview
                      packageItem={digitalSet}
                      subject={state.subject}
                    />
                  </li>
                </ul>
              </li>
            )}
          </ul>
          <Box display="flex" justifyContent="center" mt={2}>
            <LoadingButton
              isLoading={state.isAddingToCart}
              variant="primary"
              color="primary"
              onClick={handleUpdateCart}
            >
              {mode == "update"
                ? t("Update package in cart")
                : useBuyNow
                  ? t("Buy now")
                  : t("Add package to cart")}
            </LoadingButton>
          </Box>
          {editPackageItemUuid != "" && (
            <TemplateInstanceProvider>
              <EditPackageItem
                packageItem={state.packageItems.find(
                  (pi) => pi.uuid == editPackageItemUuid,
                )}
                handleCartButtonClick={handleCartButtonClick}
                allowSubjectChange={state.allowSubjectChange}
                handleChangeAllPictures={handleChangeAllPictures}
                handleGoBack={() => setEditPackageItemUuid("")}
              />
            </TemplateInstanceProvider>
          )}
        </Box>
      </Container>
    </GreenScreenBackgroundsProvider>
  );
};

const PackageItemContainer = ({ packageItem, onEdit }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classes.packageItemContainer}>
      <div className={classes.templatePreviewContainer} onClick={onEdit}>
        <TemplateProductPreview
          templateUuid={packageItem.template.uuid}
          userResources={packageItem.templateData.userResources}
          clientCompatibilityDate={
            packageItem.templateData.clientCompatibilityDate
          }
        />
        <IconButton
          color="primary"
          variant="contained"
          sx={{
            position: "absolute",
            right: "18px",
            bottom: "-9px",
            backgroundColor: "primary.main",
            color: "common.white",
            borderRadius: "4px",
            padding: "7px",
            "& .material-icons": {
              fontSize: "1rem",
            },
          }}
          size="small"
          onClick={onEdit}
          fullWidth={false}
          aria-label={t("Edit template %s", {
            postProcess: "sprintf",
            sprintf: [packageItem.template.name],
          })}
        >
          <Icon>edit</Icon>
        </IconButton>
      </div>
      <div className={classes.templateName}>
        {packageItem.template.name} {packageItem.version}
      </div>
    </div>
  );
};

const EditPackageItem = ({
  packageItem,
  handleGoBack,
  handleCartButtonClick,
  handleChangeAllPictures,
  allowSubjectChange,
}) => {
  const [template] = useTemplate(packageItem.template.uuid);
  const [state, dispatch] = useTemplateInstance();
  const { getProductByUuid } = usePriceList();
  const { t } = useTranslation();

  const initialTemplateInstance = useEffect(() => {
    if (!template) {
      return;
    }

    const product = getProductByUuid(packageItem.product.uuid);
    const { year, userResources, clientCompatibilityDate } =
      packageItem.templateData;

    const inst = createInstance(template, userResources, year, product);
    inst.partOfPackage = true;
    inst.clientCompatibilityDate = clientCompatibilityDate;

    console.log("Dispatch", dispatch, inst);
    dispatch({
      type: ACTIONS.SET_TEMPLATE_INSTANCE,
      templateInstance: inst,
    });
  }, [template, packageItem]);

  console.log("Edit package item", template, initialTemplateInstance);

  if (!template) {
    return null;
  }

  return (
    <Dialog fullScreen={true} open={true} fullWidth={true}>
      <EditTemplateProduct
        mode="update"
        handleGoBack={handleGoBack}
        cartButtonLabel={t("Update package")}
        updateCart={handleCartButtonClick}
        allowSubjectChange={allowSubjectChange}
        allowTemplateChange={packageItem.canChangeTemplate}
        handleChangeAllPackagePictures={handleChangeAllPictures}
      />
    </Dialog>
  );
};

const DigitalSetPreview = ({ packageItem, subject }) => {
  const classes = useStyles();

  const { pictureSet } = usePictureSet(subject.uuid);

  if (!pictureSet) {
    return null;
  }

  const pictures = pictureSet.pictures
    .filter((picture) => picture.groupPicture == false)
    .slice(0, 3);

  return (
    <div className={classes.pictureSetContainer}>
      {pictures.map((picture, index) => {
        const style = {
          left: index * 20,
        };
        return (
          <div
            key={picture.uuid}
            className={classes.pictureSetImageContainer}
            style={style}
          >
            <EpmsImage uuid={picture.uuid} />
          </div>
        );
      })}
      <div className={classes.digitalFileIconContainer}>
        <DigitalFileIcon />
      </div>
    </div>
  );
};

const CataloguePreview = ({ packageItem, subject }) => {
  const classes = useStyles();
  return (
    <div className={classes.catalogueContainer}>
      <div style={{ width: "100px" }}>
        <CatalogueIcon />
      </div>
      <div>{packageItem.catalogue.name}</div>
    </div>
  );
};

const EditIcon = () => {
  return <Icon>edit</Icon>;
};

export default EditPackage;
